// The Idempotency-Key of the booking panel's POST /v1/business/bookings.
//
// A key names ONE request body. It is reused only to retry that exact body
// (a network failure: the first attempt may or may not have reached the
// server — the replay must return the same appointment, never a second one).
// Any change to the body (customer, service, staff, slot / day / «الآن»,
// source) is a different booking and gets a fresh key: reusing the old key
// would make the server replay the FIRST appointment (wrong time, yet the
// toast says «تم الحجز») or refuse the key as reused with another body.
// Pure: the caller keeps the returned slot in a ref.

import { newIdempotencyKey } from '../data/book-api';
import type { CreateBookingBody } from '../data/types';

export interface IdempotencySlot {
  key: string;
  /** Canonical form of the body the key was minted for. */
  signature: string;
}

/** Canonical JSON of the body: keys sorted, absent/undefined fields dropped. */
export function bodySignature(body: CreateBookingBody): string {
  const entries = Object.entries(body as unknown as Record<string, unknown>)
    .filter(([, v]) => v !== undefined && v !== null && v !== '')
    .sort(([a], [b]) => (a < b ? -1 : a > b ? 1 : 0));
  return JSON.stringify(entries);
}

/** The previous key when the body is identical, otherwise a fresh one. */
export function keyForBody(prev: IdempotencySlot | null, body: CreateBookingBody, mint: () => string = newIdempotencyKey): IdempotencySlot {
  const signature = bodySignature(body);
  if (prev && prev.signature === signature) return prev;
  return { key: mint(), signature };
}
